import { render } from "./CustomerSettings.vue?vue&type=template&id=25d7130b"
import script from "./CustomerSettings.vue?vue&type=script&lang=js"
export * from "./CustomerSettings.vue?vue&type=script&lang=js"
script.render = render

export default script